var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgClosed({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0202 4.02022C12.2155 3.82496 12.2155 3.50838 12.0202 3.31311C11.825 3.11785 11.5084 3.11785 11.3131 3.31311L7.66667 6.95956L4.02022 3.31311C3.82496 3.11785 3.50838 3.11785 3.31311 3.31311C3.11785 3.50838 3.11785 3.82496 3.31311 4.02022L6.95956 7.66667L3.31311 11.3131C3.11785 11.5084 3.11785 11.825 3.31311 12.0202C3.50838 12.2155 3.82496 12.2155 4.02022 12.0202L7.66667 8.37377L11.3131 12.0202C11.5084 12.2155 11.825 12.2155 12.0202 12.0202C12.2155 11.825 12.2155 11.5084 12.0202 11.3131L8.37377 7.66667L12.0202 4.02022Z"
  })));
}

export default SvgClosed;